import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SetupConversation } from '@/components/setup/setup-conversation'

export const Route = createFileRoute('/_authenticated/setup')({
  validateSearch: z.object({ inbox: z.string().optional() }),
  component: SetupPage,
})
function SetupPage() {
  const { inbox } = Route.useSearch()
  return <SetupConversation mention={inbox} />
}
